import { render, staticRenderFns } from "./AffiliateSingle.vue?vue&type=template&id=683cb0ba&"
import script from "./AffiliateSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "@/style/components/affiliate/affiliate.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports